import React, { useState, useEffect, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { IoIosArrowForward } from "react-icons/io";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import Bread from "../../common/Bread";
import Loader from "../../common/Loader";
import { LangContext } from "../../context/LangContext";
import "./products.scss";

const Products = () => {
  const breadcrumList = {
    image: "",
    title: "Our Products",
    l1: "Home",
    l2: "Products",
    l3: "",
  };

  const { slug } = useParams();
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(slug);

  const lang = useContext(LangContext);
  const isNepali = lang?.state?.np;

  useEffect(() => {
    setIsActive(slug);
  }, [slug]);

  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ["productsData"],
    queryFn: () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/product/all`)
        .then((res) => res.data),
  });

  const capFirstLetterInSentence = (sentence) => {
    if (!sentence) return "";
    return sentence
      .toLowerCase()
      .split(" ")
      .map((word) => word[0]?.toUpperCase() + word.slice(1))
      .join(" ");
  };

  if (isLoading || isFetching) return <Loader />;
  if (error) return <div className="error-message">Error: {error.message}</div>;

  // Get localized data
  const localizedItems = isNepali ? data.items.np : data.items.en;
  console.log("data", data.items);
  return (
    <Bread data={breadcrumList}>
      <div className="servicePageContainer">
        {/* Product Content */}
        <div className="contentContainer">
          {localizedItems.map((item, index) => (
            <div
              key={index}
              className="content"
              style={{ display: isActive === item.slug ? "block" : "none" }}
            >
              <h2 className="content-title">
                {capFirstLetterInSentence(item.title)}
              </h2>
              <div
                className="services-ck-content"
                dangerouslySetInnerHTML={{
                  __html: item.Description || "No content available.",
                }}
              />
            </div>
          ))}
        </div>

        {/* Product Buttons */}
        <div className="buttons">
          <h2>{isNepali ? "हाम्रा उत्पादनहरू" : "Products"}</h2>
          {localizedItems.map((item) => (
            <div
              key={item.slug}
              onClick={() => {
                navigate(`/products/${item.slug}`);
                window.scrollTo(0, 0);
              }}
              className="btn"
              style={{
                color: isActive === item.slug ? "#fff" : "#0f2137",
                backgroundColor: isActive === item.slug ? "#003399" : "#fff",
              }}
            >
              <p
                dangerouslySetInnerHTML={{
                  __html: item?.title,
                }}
              ></p>
              <IoIosArrowForward className="icon" />
            </div>
          ))}
        </div>
      </div>
    </Bread>
  );
};

export default Products;
